import { LoanCalculationInputs } from '../../container/newCalculator/newCalculator.models'

export enum SessionStorageKeys {
	CALCULATOR_DATA = 'calculatorData',
}

/**
 * Wrapper for browser storage functions to check if we have the window object before continuing.
 * getItem returns string or null
 * setItem, removeItem, etc. return void
 * @param fn - storage function to wrap (e.g. window.sessionStorage.getItem)
 */
export const withWindowDefined = (fn: () => string | null | void) => {
	if (typeof window !== 'undefined') {
		return fn()
	}
	return undefined
}

export const getSessionStorageItem = (key: SessionStorageKeys): string | undefined => {
	return withWindowDefined(() => window.sessionStorage.getItem(key)) ?? undefined
}

export const setSessionStorageItem = (key: SessionStorageKeys, value: string): void => {
	withWindowDefined(() => window.sessionStorage.setItem(key, value))
}

export const removeSessionStorageItem = (key: SessionStorageKeys): void => {
	withWindowDefined(() => window.sessionStorage.removeItem(key))
}

export const setCalculatorDataToSessionStorage = (
	ASSET_FORMATION: LoanCalculationInputs,
	PAYMENT_REDUCTION: LoanCalculationInputs
): void => {
	const data = { ASSET_FORMATION, PAYMENT_REDUCTION }
	setSessionStorageItem(SessionStorageKeys.CALCULATOR_DATA, JSON.stringify(data))
}

export const getCalculatorDataFromSessionStorage = ():
	{ ASSET_FORMATION: LoanCalculationInputs; PAYMENT_REDUCTION: LoanCalculationInputs } | undefined => {
	const data = getSessionStorageItem(SessionStorageKeys.CALCULATOR_DATA)
	return data ? JSON.parse(data) : undefined
}

export const deleteCalculatorDataFromSessionStorage = (): void => {
	removeSessionStorageItem(SessionStorageKeys.CALCULATOR_DATA)
}
